const thankYou = {
    title: 'Thank You',
    header: 'Thank you \nfor your interest',
    message: "We'll get back to you shortly.",
    link: 'Home',
}

export default thankYou
